import {classNames, pluralize, React, useLocalStore, observer, _} from '@api'
import {WorkspaceConfig, IComment, nav, deployments, useCatalog} from '@stores'
import {DataMapper, ListPreviewCard} from 'centric-ui-components'
import * as css from './NotificationsForWorkspace.css'

export type CatalogItemChangeEventOperation = 'IMPORTED' | 'CREATE' | 'UPDATE' | 'DELETE' | 'ICREATE' | 'IUPDATE' | 'IDELETE' | 'IREORDER'

export const changeEventOperationLabels: { [operation: string]: string } = {
  IMPORTED: 'Imported',
  CREATE: 'Created',
  UPDATE: 'Changed',
  DELETE: 'Deleted',
  ICREATE: 'Created',
  IUPDATE: 'Updated',
  IDELETE: 'Deleted',
  IREORDER: 'Reordered',
  COLLECTION_SYNC: 'Collection Synced',
  COLLECTION_VERSION_SYNC: 'Collection Version Synced',
  WORKSPACE_SYNC: 'Workspace Sync'
}

export interface ICatalogItemChangeEventRaw {
  index: string
  /**
   * The raw event id - NOT the catalog item
   */
  _id: string
  /**
   * The catalog item's id
   */
  id: string
  operation: CatalogItemChangeEventOperation
  payload: { id: string, data: { before?, after?, delta? } }

  timestamp: number
  userId?: string
  source?: 'VIP' | 'C8' | string
  isNative?: boolean
}

interface MyProps {
  className?: string,
  workspace: WorkspaceConfig,
  changes: { [id: string]: { events: Array<ICatalogItemChangeEventRaw>, comments: Array<IComment> } }
  data: { [id: string]: { title?: string, images?: any } }
}

export const NotificationsForWorkspace = observer<MyProps>( function NotificationsForWorkspace({className, workspace, changes, data}) {
  const idByTimestamp = _.orderBy(
    _.keys(changes), id => _.max([...(changes[id].comments ?? []).map(c => c.timestamp), ...(changes[id].events ?? []).map(item => item.timestamp)]),
    ['asc']),
    catalog = useCatalog(),
    {strings, sidebar} = catalog

  //console.log({idByTimestamp})
  return (
    <div className={classNames(css.root, className)}>
      {idByTimestamp.map(id => {
        const {comments, events} = changes[id],
          dataMap = catalog.dataMapFor(workspace.dataMap)
        let record = data[id]

        if (workspace._id == catalog.workspaceConfig._id) {
          const images = catalog.imagesForCatalogItem({data: record})

          record = _.cloneDeep(record)
          _.set(record, dataMap.images, images)
        }

        /*
        <a className={css.events} href={nav.urlFor_string({
                            workspace: workspace._id,
                            queryParams: {...sidebar.queryParamsFor({right: {open: true, path: [{where: [{value: id}]}]}})}
                          })}>
                          */

        return (
          <div className={css.changesForItem} data-id={id} key={id}>
            <div className={css.header}>
              <a target='_blank'
                 className={css.title}
                 href={nav.urlFor_string({
                   workspace: workspace,
                   queryParams: {
                     deployment: deployments.selectedDeploymentId,
                     ...sidebar.queryParamsFor({right: {open: true, path: [{where: [{value: id}]}]}})
                   }
                 })}>
                <DataMapper data={record} config={dataMap}>
                  <ListPreviewCard
                    stores={catalog.stores}
                    className={css.card}
                   showImage={true}
                   showTooltip={false}
                    avatar={_.toUpper(workspace.itemName ? workspace.itemName[0] : 'p')}
                    extra={
                    <div className={css.extra}>
                      {events?.length > 0 &&
                       <div className={css.events}>
                        {events.length} {pluralize('change', events.length)}
                      </div>}
                      {comments?.length > 0 &&
                       <div className={css.comments}>
                        {comments.length} new {pluralize(_.toLower(strings.comments), comments.length)}
                      </div>}
                    </div>
                  }/>
                </DataMapper>
              </a>
            </div>
          </div>
        )
      })}
    </div>)
})

/*
<NotificationsForWorkspace workspace={ws} key={ws._id} changes={byIndexAndId[ws.catalog.index]} titles={titlesForIdByIndex[ws.catalog.index]} />
 */


// WEBPACK FOOTER //
// ./src/stores/notifications/NotificationsForWorkspace.tsx